export const hepatitisHeroData = {
    title: "Hepatitis & Liver Diseases",
    subtitle: "Hepatitis B, C treatment and liver disease management medications.",
    stats: [
        { number: '30+', label: 'Medications' },
        { number: 'Save up to 80%', label: 'Affordable' },
        { number: 'WHO-GMP Certified', label: 'Quality' }
    ]
};

export const hepatitisProducts = [
    {
        id: "hep-01",
        name: "Sofosbuvir 400mg",
        genericName: "Sovaldi",
        indication: "Hepatitis C",
        price: "$2,160",
        originalPrice: "$28,000",
        savings: "93%",
        description: "Direct-acting antiviral medication used as part of a combination therapy to treat chronic hepatitis C.",
        packaging: "28 Tablets",
        manufacturer: "Gilead / Licensed Generic",
        dosage: "One 400 mg tablet once daily",
        storage: "Store at 25°C (77°F); excursions permitted to 15°C–30°C (59°F–86°F).",
        sideEffects: "Fatigue, headache, nausea, insomnia, and anemia."
    },
    {
        id: "hep-02",
        name: "Ledipasvir/Sofosbuvir",
        genericName: "Harvoni",
        indication: "Hepatitis C",
        price: "$2,400",
        originalPrice: "$32,000",
        savings: "92%",
        description: "Fixed-dose combination for the treatment of chronic hepatitis C genotype 1, 4, 5, or 6.",
        packaging: "28 Tablets",
        manufacturer: "Gilead / Licensed Generic",
        dosage: "One tablet (90 mg/400 mg) once daily",
        storage: "Store below 30°C (86°F).",
        sideEffects: "Headache, fatigue, nausea, diarrhea, and insomnia."
    },
    {
        id: "hep-03",
        name: "Daclatasvir 60mg",
        genericName: "Daklinza",
        indication: "Hepatitis C",
        price: "$1,200",
        originalPrice: "$22,000",
        savings: "94%",
        description: "Used in combination with other medications for the treatment of chronic hepatitis C virus (HCV) infection.",
        packaging: "28 Tablets",
        manufacturer: "BMS / Licensed Generic",
        dosage: "60 mg orally once daily",
        storage: "Store at 20°C to 25°C (68°F to 77°F).",
        sideEffects: "Fatigue, headache, nausea, and diarrhea."
    },
    {
        id: "hep-04",
        name: "Velpatasvir/Sofosbuvir",
        genericName: "Epclusa",
        indication: "Hepatitis C",
        price: "$2,800",
        originalPrice: "$15,000",
        savings: "81%",
        description: "Pan-genotypic treatment for chronic hepatitis C virus infection.",
        packaging: "28 Tablets",
        manufacturer: "Gilead / Licensed Generic",
        dosage: "One tablet (100 mg/400 mg) once daily",
        storage: "Store below 30°C (86°F).",
        sideEffects: "Headache, fatigue, nausea, and insomnia."
    },
    {
        id: "hep-05",
        name: "Tenofovir 300mg",
        genericName: "Viread",
        indication: "Hepatitis B",
        price: "$120",
        originalPrice: "$1,200",
        savings: "90%",
        description: "Antiviral medication used to treat chronic hepatitis B and HIV/AIDS.",
        packaging: "30 Tablets",
        manufacturer: "Gilead / Licensed Generic",
        dosage: "300 mg once daily",
        storage: "Store at 25°C (77°F).",
        sideEffects: "Nausea, rash, diarrhea, headache, pain, depression, and asthenia."
    },
    {
        id: "hep-06",
        name: "Entecavir 1mg",
        genericName: "Baraclude",
        indication: "Hepatitis B",
        price: "$140",
        originalPrice: "$1,200",
        savings: "88%",
        description: "Oral antiviral drug used in the treatment of hepatitis B infection.",
        packaging: "30 Tablets",
        manufacturer: "BMS / Licensed Generic",
        dosage: "0.5 mg or 1 mg once daily on an empty stomach",
        storage: "Store in a tightly closed container at 25°C (77°F).",
        sideEffects: "Headache, nausea, dizziness, and fatigue."
    },
    {
        id: "hep-07",
        name: "Ribavirin 200mg",
        genericName: "Copegus",
        indication: "Hepatitis C",
        price: "$35",
        originalPrice: "$1,500",
        savings: "97%",
        description: "Antiviral medication used to treat RSV infection, hepatitis C, and viral hemorrhagic fever.",
        packaging: "140 Capsules",
        manufacturer: "Roche / Licensed Generic",
        dosage: "Weight-based, typically 400-600mg twice daily",
        storage: "Store at 25°C (77°F).",
        sideEffects: "Anemia, fatigue, headache, nausea, and skin reaction."
    },
    {
        id: "hep-08",
        name: "Adefovir 10mg",
        genericName: "Hepsera",
        indication: "Hepatitis B",
        price: "$180",
        originalPrice: "$2,000",
        savings: "91%",
        description: "Prescription medicine used to treat chronic hepatitis B virus infection in adults.",
        packaging: "30 Tablets",
        manufacturer: "Gilead / Licensed Generic",
        dosage: "10 mg once daily with or without food",
        storage: "Store at 25°C (77°F).",
        sideEffects: "Weakness, headache, abdominal pain, and nausea."
    },
    {
        id: "hep-09",
        name: "Lamivudine 150mg",
        genericName: "Epivir-HBV",
        indication: "Hepatitis B",
        price: "$80",
        originalPrice: "$1,200",
        savings: "93%",
        description: "Used to treat chronic hepatitis B and prevent HIV infection in those exposed.",
        packaging: "60 Tablets",
        manufacturer: "GSK / Licensed Generic",
        dosage: "100 mg once daily for HBV",
        storage: "Store at 25°C (77°F).",
        sideEffects: "Nausea, diarrhea, headache, fatigue, and insomnia."
    },
    {
        id: "hep-10",
        name: "Telbivudine 600mg",
        genericName: "Tyzeka",
        indication: "Hepatitis B",
        price: "$160",
        originalPrice: "$1,500",
        savings: "89%",
        description: "Antiviral drug used in the treatment of hepatitis B infection.",
        packaging: "30 Tablets",
        manufacturer: "Novartis / Licensed Generic",
        dosage: "600 mg once daily with or without food",
        storage: "Store at 25°C (77°F).",
        sideEffects: "Increased creatine kinase, fatigue, headache, and nausea."
    },
    {
        id: "hep-11",
        name: "Glecaprevir/Pibrentasvir",
        genericName: "Mavyret",
        indication: "Hepatitis C",
        price: "$2,000",
        originalPrice: "$23,000",
        savings: "91%",
        description: "Pan-genotypic treatment for adults and children with chronic HCV.",
        packaging: "84 Tablets",
        manufacturer: "AbbVie / Licensed Generic",
        dosage: "Three tablets (100 mg/400 mg) once daily with food",
        storage: "Store at or below 30°C (86°F).",
        sideEffects: "Headache, fatigue, and nausea."
    },
    {
        id: "hep-12",
        name: "Elbasvir/Grazoprevir",
        genericName: "Zepatier",
        indication: "Hepatitis C",
        price: "$1,800",
        originalPrice: "$20,000",
        savings: "91%",
        description: "Combination medication for the treatment of chronic hepatitis C genotypes 1 or 4.",
        packaging: "28 Tablets",
        manufacturer: "Merck / Licensed Generic",
        dosage: "One tablet once daily",
        storage: "Store at 20°C to 25°C (68°F to 77°F).",
        sideEffects: "Fatigue, headache, and nausea."
    },
    {
        id: "hep-13",
        name: "Tenofovir Alafenamide 25mg",
        genericName: "Vemlidy",
        indication: "Hepatitis B",
        price: "$130",
        originalPrice: "$1,500",
        savings: "91%",
        description: "Effective treatment for chronic hepatitis B virus infection in adults with compensated liver disease.",
        packaging: "30 Tablets",
        manufacturer: "Gilead / Licensed Generic",
        dosage: "25 mg once daily with food",
        storage: "Store below 30°C (86°F).",
        sideEffects: "Headache, abdominal pain, fatigue, cough, nausea, and back pain."
    },
    {
        id: "hep-14",
        name: "Peginterferon alfa-2a",
        genericName: "Pegasys",
        indication: "Hepatitis B & C",
        price: "$520",
        originalPrice: "$3,000",
        savings: "83%",
        description: "Injectable medication used to treat chronic hepatitis C and chronic hepatitis B.",
        packaging: "1 Prefilled Syringe",
        manufacturer: "Roche / Licensed Generic",
        dosage: "180 mcg once weekly by subcutaneous injection",
        storage: "Store in the refrigerator at 2°C to 8°C (36°F to 46°F). Do not freeze.",
        sideEffects: "Flu-like symptoms, fatigue, depression, and low blood counts."
    },
    {
        id: "hep-15",
        name: "Simeprevir 150mg",
        genericName: "Olysio",
        indication: "Hepatitis C",
        price: "$1,400",
        originalPrice: "$13,000",
        savings: "89%",
        description: "NS3/4A protease inhibitor for the treatment of chronic hepatitis C genotype 1.",
        packaging: "28 Capsules",
        manufacturer: "Janssen / Licensed Generic",
        dosage: "150 mg once daily with food",
        storage: "Store below 30°C (86°F).",
        sideEffects: "Rash, pruritus, nausea, and myalgia."
    },
    {
        id: "hep-16",
        name: "Paritaprevir/Ritonavir/Ombitasvir",
        genericName: "Viekira Pak",
        indication: "Hepatitis C",
        price: "$1,980",
        originalPrice: "$20,000",
        savings: "90%",
        description: "Combination treatment for chronic hepatitis C virus genotype 1 infection.",
        packaging: "Daily Pack",
        manufacturer: "AbbVie / Licensed Generic",
        dosage: "As directed in the package",
        storage: "Store at 20°C to 25°C (68°F to 77°F).",
        sideEffects: "Nausea, itching, and insomnia."
    },
    {
        id: "hep-17",
        name: "Sofosbuvir/Velpatasvir/Voxilaprevir",
        genericName: "Vosevi",
        indication: "Hepatitis C",
        price: "$3,000",
        originalPrice: "$13,000",
        savings: "83%",
        description: "Treatment for adults with chronic HCV who have previously been treated with an HCV drug.",
        packaging: "28 Tablets",
        manufacturer: "Gilead / Licensed Generic",
        dosage: "One tablet once daily with food",
        storage: "Store below 30°C (86°F).",
        sideEffects: "Headache, fatigue, diarrhea, and nausea."
    },
    {
        id: "hep-18",
        name: "Ursodeoxycholic Acid 300mg",
        genericName: "Urso / Udiliv",
        indication: "Liver Disease",
        price: "$50",
        originalPrice: "$500",
        savings: "90%",
        description: "Bile acid that helps dissolve certain types of gallstones and treats primary biliary cholangitis.",
        packaging: "100 Tablets",
        manufacturer: "Allergan / Generic",
        dosage: "13-15 mg/kg/day in 2 to 4 divided doses",
        storage: "Store at 20°C to 25°C (68°F to 77°F).",
        sideEffects: "Diarrhea, constipation, upset stomach, and back pain."
    },
    {
        id: "hep-19",
        name: "Silymarin 140mg",
        genericName: "Milk Thistle",
        indication: "Liver Support",
        price: "$15",
        originalPrice: "$120",
        savings: "87%",
        description: "Herbal supplement used for liver support and detoxification.",
        packaging: "60 Capsules",
        manufacturer: "Generic",
        dosage: "140 mg twice daily",
        storage: "Store in a cool, dry place.",
        sideEffects: "Abdominal bloating/pain, allergic reactions, and diarrhea."
    },
    {
        id: "hep-20",
        name: "Lactulose Solution",
        genericName: "Enulose",
        indication: "Liver Disease",
        price: "$26",
        originalPrice: "$200",
        savings: "87%",
        description: "Used to treat constipation and prevent hepatic encephalopathy.",
        packaging: "500ml",
        manufacturer: "Generic",
        dosage: "15-30 ml daily for constipation",
        storage: "Store at 15°C to 30°C (59°F to 86°F). Do not freeze.",
        sideEffects: "Bloating, gas, stomach pain, and diarrhea."
    },
    {
        id: "hep-21",
        name: "Rifaximin 550mg",
        genericName: "Xifaxan",
        indication: "Liver Disease",
        price: "$120",
        originalPrice: "$1,800",
        savings: "93%",
        description: "Antibiotic used to reduce the risk of overt hepatic encephalopathy recurrence.",
        packaging: "60 Tablets",
        manufacturer: "Bausch Health / Generic",
        dosage: "550 mg twice daily",
        storage: "Store at 20°C to 25°C (68°F to 77°F).",
        sideEffects: "Nausea, flatulence, headache, and fatigue."
    },
    {
        id: "hep-22",
        name: "Spironolactone 100mg",
        genericName: "Aldactone",
        indication: "Liver Cirrhosis",
        price: "$15",
        originalPrice: "$150",
        savings: "90%",
        description: "Diuretic used to treat fluid build-up due to liver disease.",
        packaging: "30 Tablets",
        manufacturer: "Pfizer / Generic",
        dosage: "100-400 mg daily",
        storage: "Store below 25°C (77°F).",
        sideEffects: "Fatigue, headache, dizziness, and gynecomastia."
    },
    {
        id: "hep-23",
        name: "Furosemide 40mg",
        genericName: "Lasix",
        indication: "Edema",
        price: "$8",
        originalPrice: "$50",
        savings: "84%",
        description: "Loop diuretic used to treat fluid retention in people with congestive heart failure or liver disease.",
        packaging: "30 Tablets",
        manufacturer: "Sanofi / Generic",
        dosage: "20-80 mg daily",
        storage: "Store at 25°C (77°F).",
        sideEffects: "Dehydration, electrolyte imbalance, and dizziness."
    },
    {
        id: "hep-24",
        name: "Propranolol 40mg",
        genericName: "Inderal",
        indication: "Portal Hypertension",
        price: "$10",
        originalPrice: "$100",
        savings: "90%",
        description: "Beta-blocker used to prevent bleeding in patients with esophageal varices.",
        packaging: "30 Tablets",
        manufacturer: "Generic",
        dosage: "As prescribed by physician",
        storage: "Store at 25°C (77°F).",
        sideEffects: "Fatigue, cold extremities, and sleep disturbances."
    },
    {
        id: "hep-25",
        name: "Vitamin K1 10mg",
        genericName: "Mephyton",
        indication: "Blood Clotting",
        price: "$15",
        originalPrice: "$150",
        savings: "90%",
        description: "Essential for blood clotting, often needed in patients with severe liver disease.",
        packaging: "30 Tablets",
        manufacturer: "Generic",
        dosage: "2.5-25 mg daily",
        storage: "Store at controlled room temperature.",
        sideEffects: "Dizziness, sweating, and flushing."
    },
    {
        id: "hep-26",
        name: "Albumin 25%",
        genericName: "Human Albumin",
        indication: "Liver Failure",
        price: "$90",
        originalPrice: "$450",
        savings: "80%",
        description: "Intravenous protein solution used for patients with liver failure and ascites.",
        packaging: "100ml Vial",
        manufacturer: "Generic",
        dosage: "As directed by physician",
        storage: "Store at controlled room temperature.",
        sideEffects: "Allergic reactions, fever, and chills."
    },
    {
        id: "hep-27",
        name: "Zinc Sulfate 220mg",
        genericName: "Zinc",
        indication: "Liver Support",
        price: "$5",
        originalPrice: "$15",
        savings: "66%",
        description: "Supplement often used in patients with liver cirrhosis to address deficiency.",
        packaging: "100 Tablets",
        manufacturer: "Generic",
        dosage: "As prescribed",
        storage: "Store in a cool, dry place.",
        sideEffects: "Nausea, stomach pain, and diarrhea."
    },
    {
        id: "hep-28",
        name: "Obeticholic Acid 5mg",
        genericName: "Ocaliva",
        indication: "Liver Disease",
        price: "$280",
        originalPrice: "$8,000",
        savings: "96%",
        description: "Used to treat primary biliary cholangitis (PBC) in adults.",
        packaging: "30 Tablets",
        manufacturer: "Intercept / Generic",
        dosage: "5 mg once daily",
        storage: "Store at 20°C to 25°C (68°F to 77°F).",
        sideEffects: "Pruritus, fatigue, and abdominal pain."
    },
    {
        id: "hep-29",
        name: "Budesonide 3mg",
        genericName: "Entocort EC",
        indication: "Autoimmune Hepatitis",
        price: "$450",
        originalPrice: "$1,500",
        savings: "70%",
        description: "Steroid used to treat certain autoimmune liver and inflammatory conditions.",
        packaging: "100 Capsules",
        manufacturer: "Takeda / Generic",
        dosage: "9 mg orally once daily",
        storage: "Store at 25°C (77°F).",
        sideEffects: "Headache, nausea, and respiratory infection."
    },
    {
        id: "hep-30",
        name: "Terlipressin",
        genericName: "Glypressin",
        indication: "Liver Complications",
        price: "$50",
        originalPrice: "$350",
        savings: "85%",
        description: "Used in the treatment of esophageal varices and hepatorenal syndrome.",
        packaging: "1 Injection",
        manufacturer: "Ferring / Generic",
        dosage: "I.V. injection as directed",
        storage: "Store in refrigerator (2°C-8°C).",
        sideEffects: "Abdominal pain, nausea, and headache."
    }
];

export const hepatitisCategories = [
    "All Categories",
    "Hepatitis C",
    "Hepatitis B",
    "Liver Disease",
    "Liver Support"
];

export const hepatitisTrustBadges = [
    { icon: 'ShieldCheck', text: 'WHO GMP Certified' },
    { icon: 'Users', text: 'Used by 50,000+ Patients' },
    { icon: 'Plane', text: 'Global Delivery in 7-10 Days' },
    { icon: 'Award', text: '100% Authentic Guarantee' }
];

export const hepatitisFAQs = [
    {
        question: "How do I know these medications are authentic?",
        answer: "All our medications are sourced directly from WHO-GMP certified facilities and reputable Indian generic manufacturers (like Gilead licensed partners). Every pack comes with original batch numbers and certificates of analysis upon request."
    },
    {
        question: "Do you ship Hepatitis medications internationally?",
        answer: "Yes, we ship globally to over 100 countries including USA, Europe, and Asia. We use discreet packaging and guaranteed delivery services to ensure your medication reaches you safely."
    }
];

export const hepatitisTestimonials = [
    {
        name: "Robert M.",
        country: "UK",
        savings: "$25,000",
        condition: "Hepatitis C",
        medication: "Sofosbuvir + Daclatasvir",
        text: "I was quoted over £30,000 for my treatment locally. MediSeller provided the exact same generic equivalent for a fraction of the cost. Six months later, I am virus-free!"
    },
    {
        name: "James L.",
        country: "USA",
        savings: "$28,000",
        condition: "Hepatitis B",
        medication: "Entecavir",
        text: "The cost of medication in the US was unsustainable. MediSeller has been a lifesaver, providing reliable delivery and authentic medication every time."
    }
];

export const hepatitisSectionContent = {
    midPageCTA: {
        title: "Can't Find Your Medication?",
        description: "We have access to 5000+ generic medications. Our specialists can help you source any medication from verified Indian manufacturers at up to 80% savings.",
        whatsappText: "Chat on WhatsApp",
        requestText: "Submit Custom Request"
    },
    testimonials: {
        title: "Patient Success Stories",
        description: "Hear from patients worldwide who saved thousands on their hepatitis & liver diseases"
    },
    faqs: {
        title: "Frequently Asked Questions",
        description: "Everything you need to know about ordering hepatitis & liver diseases"
    },
    finalCTA: {
        title: "Ready to Save on Your Treatment?",
        description: "Get expert consultation and authentic hepatitis & liver diseases delivered directly to your doorstep.",
        whatsappText: "Start WhatsApp Chat",
        requestText: "Request Free Consultation"
    }
};
